import React, { CSSProperties } from 'react';
import { observer } from 'mobx-react';
import ClipLoader from 'react-spinners/ClipLoader';

import { COLORS } from 'shared/constants';

import './styles.scss';

type PropsType = {
    style?: CSSProperties;
    size?: number;
    children?: React.ReactNode;
    isLoading?: boolean;
};
export const UiLoadingSpinner = observer(function UiLoadingSpinner({ style, size = 24, children, isLoading = true }: PropsType) {
    if (!isLoading) {
        return children;
    }

    return (
        <div className="ui-new-loading-spinner" style={style}>
            <ClipLoader size={size} color={COLORS._2C2F35} />
        </div>
    );
});
